import React from 'react';
import { TopBar } from './components/TopBar';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { ValueProposition } from './components/ValueProposition';
import { SolutionSection } from './components/SolutionSection';
import { VisualImpact } from './components/VisualImpact';
import { ModulesSection } from './components/ModulesSection';
import { BonusesSection } from './components/BonusesSection';
import { TransformationSection } from './components/TransformationSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ValueStack } from './components/ValueStack';
import { TrustSection } from './components/TrustSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-black selection:bg-brand-gold/30 selection:text-brand-dark" data-id="element-0">
      <TopBar data-id="element-1" />
      <Header data-id="element-2" />
      <HeroSection data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <ValueProposition data-id="element-5" />
      <SolutionSection data-id="element-6" />
      <VisualImpact data-id="element-7" />
      <ModulesSection data-id="element-8" />
      <BonusesSection data-id="element-9" />
      <TransformationSection data-id="element-10" />
      <BenefitsSection data-id="element-11" />
      <ValueStack data-id="element-12" />
      <TrustSection data-id="element-13" />
      <OfferSection data-id="element-14" />
      <GuaranteeSection data-id="element-15" />
      <FinalCTA data-id="element-16" />
      <Footer data-id="element-17" />
    </div>;
}